/**
 * Which flagcdn.com flag represents each real football competition — keyed
 * by `competitions.slug`, since that's stable and known client-side without
 * a round trip (unlike a subdivision code, which would need its own column
 * on `competitions`).
 *
 * England and Scotland have their own flagcdn subdivision codes (`gb-eng`,
 * `gb-sct`) distinct from the Union Jack (`gb`) — the Premier League and
 * Championship use England's, not Great Britain's.
 *
 * Absent from this map: World Cup and dev-fixtures (many countries, no
 * single flag fits), and every custom competition (organizer-defined,
 * nothing to look up).
 */
const COMPETITION_FLAG_CODES: Record<string, string> = {
  'la-liga-2026-27': 'es',
  'brasileirao-2026': 'br',
  'premier-league-2026-27': 'gb-eng',
  'championship-2026-27': 'gb-eng',
  'ligue-1-2026-27': 'fr',
  'bundesliga-2026-27': 'de',
  'serie-a-2026-27': 'it',
  'eredivisie-2026-27': 'nl',
  'primeira-liga-2026-27': 'pt',
};

export function flagCodeForCompetition(slug: string): string | null {
  return COMPETITION_FLAG_CODES[slug] ?? null;
}
